import React, { useState, useEffect } from "react";
import { Button, Input } from "reactstrap";
import LiveTicketScannerModal from "./LiveTicketScannerModalNew";

import "./TicketNumberScannerInput.css";

const TicketNumberScannerInput = ({ id = "ticketNum", name = "ticketNum", value = "", placeholder = "ticket number", disabled = false, onChange, onDetected, autoFocusOnMount = false, autoStartScan = false }) => {
    const inputRef = React.useRef(null);
    const [isScanning, setIsScanning] = useState(false);
    const [scanError, setScanError] = useState("");
    const [liveScanOpen, setLiveScanOpen] = useState(false);

    useEffect(() => {
        if (autoFocusOnMount && inputRef.current) inputRef.current.focus();
    }, [autoFocusOnMount]);

    useEffect(() => {
        if (!autoStartScan || disabled || isScanning) return;
        const t = setTimeout(() => {
            setLiveScanOpen(true);
        }, 120);
        return () => clearTimeout(t);
    }, [autoStartScan, disabled, isScanning]);

    function handleManualChange(e) {
        const digitsOnly = String(e.target.value || "").replace(/\D/g, "");
        if (onChange) {
            onChange({
                ...e,
                target: {
                    ...e.target,
                    name,
                    value: digitsOnly,
                },
            });
        }
    }

    return (
        <div className="tnsi-wrap">
            <div className="tnsi-row">
                <Input
                    innerRef={inputRef}
                    id={id}
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleManualChange}
                    disabled={disabled}
                />
                <Button
                    type="button"
                    className="tnsi-btn"
                    onClick={() => {
                        setScanError("");
                        setIsScanning(true);
                        setLiveScanOpen(true);
                    }}
                    disabled={disabled || isScanning}>
                    Live Scan
                </Button>
            </div>

            <LiveTicketScannerModal
                isOpen={liveScanOpen}
                toggle={() => {
                    setLiveScanOpen((v) => !v);
                    setIsScanning(false);
                }}
                onDetected={(ticket) => {
                    setIsScanning(false);
                    if (onDetected) onDetected(ticket);
                }}
            />

            {scanError ? <div className="tnsi-error">{scanError}</div> : null}
        </div>
    );
};

export default TicketNumberScannerInput;
